import { render, staticRenderFns } from "./Approvate.vue?vue&type=template&id=46d7b5e2"
import script from "./Approvate.vue?vue&type=script&lang=js"
export * from "./Approvate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports